import { render, staticRenderFns } from "./card-professional-community.vue?vue&type=template&id=f18c7d52&scoped=true&"
import script from "./card-professional-community.vue?vue&type=script&lang=js&"
export * from "./card-professional-community.vue?vue&type=script&lang=js&"
import style0 from "./card-professional-community.vue?vue&type=style&index=0&id=f18c7d52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f18c7d52",
  null
  
)

export default component.exports